'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookTheme = require('@narvar/nth-hook-theme');
var Button = require('@narvar/nth-block-button');
var Footer_module = require('./Footer.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Button__default = /*#__PURE__*/_interopDefaultLegacy(Button);

const ButtonItem = _ref => {
  let {
    button,
    onEvent
  } = _ref;
  if ( /*#__PURE__*/React.isValidElement(button)) return button;
  const buttonData = button;
  const handleClick = () => onEvent === null || onEvent === void 0 ? void 0 : onEvent({
    value: buttonData.type,
    area: 'navigation',
    event: 'click'
  });
  return /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
    onClick: handleClick,
    disabled: buttonData.disabled,
    outline: buttonData.outline,
    big: buttonData.big
  }, buttonData.label ?? buttonData.type);
};
const ButtonRow = _ref2 => {
  let {
    buttons,
    onEvent
  } = _ref2;
  return /*#__PURE__*/React__default["default"].createElement("nav", {
    className: Footer_module["default"].buttonWrapper
  }, (buttons === null || buttons === void 0 ? void 0 : buttons.leftButton) && /*#__PURE__*/React__default["default"].createElement("div", {
    className: Footer_module["default"].leftItem
  }, /*#__PURE__*/React__default["default"].createElement(ButtonItem, {
    onEvent: onEvent,
    button: buttons.leftButton
  })), (buttons === null || buttons === void 0 ? void 0 : buttons.centerButton) && /*#__PURE__*/React__default["default"].createElement("div", {
    className: Footer_module["default"].item
  }, /*#__PURE__*/React__default["default"].createElement(ButtonItem, {
    onEvent: onEvent,
    button: buttons.centerButton
  })), (buttons === null || buttons === void 0 ? void 0 : buttons.rightButton) && /*#__PURE__*/React__default["default"].createElement("div", {
    className: Footer_module["default"].rightItem
  }, /*#__PURE__*/React__default["default"].createElement(ButtonItem, {
    onEvent: onEvent,
    button: buttons.rightButton
  })));
};
const FooterC = /*#__PURE__*/React.forwardRef((_ref3, ref) => {
  let {
    children,
    buttons,
    onEvent,
    above,
    below,
    divider,
    progressiveStep,
    activeStep
  } = _ref3;
  const {
    panelcontainerNoneNone
  } = nthHookTheme.useTheme();
  const dividerThemeStyle = {
    borderTopColor: (panelcontainerNoneNone === null || panelcontainerNoneNone === void 0 ? void 0 : panelcontainerNoneNone.borderTopColor) ?? '#ccc',
    borderTopWidth: (panelcontainerNoneNone === null || panelcontainerNoneNone === void 0 ? void 0 : panelcontainerNoneNone.borderTopWidth) ?? '1px',
    borderTopStyle: (panelcontainerNoneNone === null || panelcontainerNoneNone === void 0 ? void 0 : panelcontainerNoneNone.borderTopStyle) ?? 'solid'
  };
  const show = !progressiveStep || activeStep;
  return show ? /*#__PURE__*/React__default["default"].createElement("footer", {
    className: Footer_module["default"].footer,
    ref: ref
  }, above, divider && above && /*#__PURE__*/React__default["default"].createElement("hr", {
    className: Footer_module["default"].divider,
    style: dividerThemeStyle
  }), children || /*#__PURE__*/React__default["default"].createElement(ButtonRow, {
    buttons,
    onEvent
  }), divider && below && /*#__PURE__*/React__default["default"].createElement("hr", {
    className: Footer_module["default"].divider,
    style: dividerThemeStyle
  }), below) : null;
});
FooterC.displayName = 'FooterC';
var Footer = nthHookTheme.withThemeProvider(FooterC, {
  themeTokens: ['documentbodyNoneNone', 'panelcontainerNoneNone', 'buttonsPrimaryDefault', 'buttonsPrimaryHover', 'buttonsSecondaryDefault']
});

exports["default"] = Footer;
